import { lazy } from 'react';
import MainLayout from 'layouts/MainLayout';

const LandingPage = lazy(() => import('../pages/LandingPage'));
const ProjectPage = lazy(() => import('../pages/ProjectPage'));
const PresentationPage = lazy(() => import('../pages/PresentationPage'));

const routes = [{
    layout: MainLayout,
    routes: [{
        path: '/agents/esg-report-creator/:agentId',
        element: LandingPage,
        exact: true,
        analytics: { name: ["Agente", "ESG Report Creator"] },
    }, {
        path: '/agents/esg-report-creator/:agentId/conversations/:conversationId',
        element: ProjectPage,
        exact: true,
        analytics: { name: ["Agente", "ESG Report Creator", "Progetto"] },
    }, {
        path: '/agents/esg-report-creator/:agentId/conversations/:conversationId/presentation',
        element: PresentationPage,
        exact: true,
        analytics: { name: ["Agente", "ESG Report Creator", "Report"] },
    }]
}];

export default routes;
